import DashboardSidebarItems from './DashboardSidebarItems';

export default DashboardSidebarItems;
